import { render, staticRenderFns } from "./getAttr.vue?vue&type=template&id=b003051a&scoped=true&"
import script from "./getAttr.vue?vue&type=script&lang=js&"
export * from "./getAttr.vue?vue&type=script&lang=js&"
import style0 from "./getAttr.vue?vue&type=style&index=0&id=b003051a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003051a",
  null
  
)

export default component.exports